__turbopack_context__.v({
  "backLink": "venus-enquiry-form-module__4u1Z0W__backLink",
  "choiceCard": "venus-enquiry-form-module__4u1Z0W__choiceCard",
  "choiceGrid": "venus-enquiry-form-module__4u1Z0W__choiceGrid",
  "choiceSub": "venus-enquiry-form-module__4u1Z0W__choiceSub",
  "choiceTitle": "venus-enquiry-form-module__4u1Z0W__choiceTitle",
  "diagram": "venus-enquiry-form-module__4u1Z0W__diagram",
  "dial": "venus-enquiry-form-module__4u1Z0W__dial",
  "dialTrack": "venus-enquiry-form-module__4u1Z0W__dialTrack",
  "dialTraveler": "venus-enquiry-form-module__4u1Z0W__dialTraveler",
  "divider": "venus-enquiry-form-module__4u1Z0W__divider",
  "emailInput": "venus-enquiry-form-module__4u1Z0W__emailInput",
  "line": "venus-enquiry-form-module__4u1Z0W__line",
  "lock": "venus-enquiry-form-module__4u1Z0W__lock",
  "lockShackle": "venus-enquiry-form-module__4u1Z0W__lockShackle",
  "moat": "venus-enquiry-form-module__4u1Z0W__moat",
  "note": "venus-enquiry-form-module__4u1Z0W__note",
  "progress": "venus-enquiry-form-module__4u1Z0W__progress",
  "recap": "venus-enquiry-form-module__4u1Z0W__recap",
  "recapKey": "venus-enquiry-form-module__4u1Z0W__recapKey",
  "root": "venus-enquiry-form-module__4u1Z0W__root",
  "step": "venus-enquiry-form-module__4u1Z0W__step",
  "step-in": "venus-enquiry-form-module__4u1Z0W__step-in",
  "tinyText": "venus-enquiry-form-module__4u1Z0W__tinyText",
  "workload": "venus-enquiry-form-module__4u1Z0W__workload",
  "youFill": "venus-enquiry-form-module__4u1Z0W__youFill",
  "youText": "venus-enquiry-form-module__4u1Z0W__youText",
});
